import { FC } from 'react';
import * as React from 'react';

import { FormRenderProps } from 'react-final-form';
import { ModalComponentProps } from '../modal/ModalManager';
import { Yup } from '../validation/yup';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { Card } from '../card/Card';
import { Block } from '../block/Block';
import { Col, Row } from '../row';
import {
  Button,
  CloseButton,
  DialogFooter,
  makeValidate,
  modalFormDialog,
  VF,
} from '../index';

type FormData = {
  url: string;
};

type LinkDialogProps = {
  formRenderProps: FormRenderProps<FormData>;
  canDelete?: boolean;
  onDelete: () => void;
} & ModalComponentProps;

export const editZadostValidateSchema = Yup.object().shape({
  url: Yup.string().required(),
});

const validation = makeValidate(editZadostValidateSchema);

const LinkDialog: FC<LinkDialogProps> = ({
  onClose,
  canDelete,
  onDelete,
  formRenderProps: { handleSubmit, submitting },
}) => {
  return (
    <Dialog size={'md'} onClose={onClose} title={'Odkaz'}>
      <DialogBody>
        <Card mode={'edit'}>
          <Block>
            <Row>
              <Col>
                <VF.String required name={'url'} label={'URL'} />
              </Col>
            </Row>
          </Block>
        </Card>
      </DialogBody>
      <DialogFooter
        extra={
          <>
            {canDelete && (
              <Button className={'float-left'} danger onClick={onDelete}>
                Odebrat
              </Button>
            )}
          </>
        }
      >
        <CloseButton mode={'edit'} disabled={submitting} onClick={onClose} />
        <Button disabled={submitting} style={'primary'} onClick={handleSubmit}>
          Ok
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export const LinkModalForm = modalFormDialog<FormData, LinkDialogProps>(
  LinkDialog,
  {
    validate: validation,
  }
);
